<script>
import { ref } from "vue";
const value = ref();
const currentDate = ref(new Date());
export default {
  data() {
    return {
      startdate: currentDate,
      dateFormat: "dd-MM-yyyy",
      showFilterInputs: false,
      CustomSelec: ["Customer ID", "CU0263", "CU3695"],
      RaySelect: ["Customer", "Anthony Lewis", "Linda Ray"],
      CustomActive: ["Status", "Active", "Inative"],
    };
  },
  methods: {
    toggleFilterInputs() {
      this.showFilterInputs = !this.showFilterInputs;
    },
  },
};
</script>
<template>
  <div class="provider-page">
    <provider-sidebar></provider-sidebar>
    <provider-header></provider-header>

    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <h4 class="mb-4">Customers Details</h4>
        <div class="row">
          <div class="col-xxl-6 col-lg-6">
            <div class="card">
              <div class="card-body">
                <div class="d-flex justify-content-between pb-3 border-bottom mb-3">
                  <h6>Personal Info</h6>
                  <span class="badge badge-success-100 d-flex align-items-center"
                    ><i class="ti ti-point-filled me-1"></i>Active</span
                  >
                </div>
                <div class="d-flex align-items-center mb-4">
                  <span class="avatar avatar-lg flex-shrink-0 me-2">
                    <img
                      src="@/assets/img/user/user-01.jpg"
                      class="rounded-circle"
                      alt="Img"
                    />
                  </span>
                  <div>
                    <div class="d-flex flex-wrap row-gap-2">
                      <h6 class="me-2 fw-medium">Harvey Smith</h6>
                      <span class="badge bg-primary-transparent">
                        Last Booking : 16/04/2024
                      </span>
                    </div>
                    <span class="fs-14">harvey@example.com</span>
                  </div>
                </div>
                <div
                  class="d-flex justify-content-between align-items-center flex-wrap row-gap-2"
                >
                  <div>
                    <h6 class="fs-14">Phone</h6>
                    <span class="fs-14">+1 634 967 2145</span>
                  </div>
                  <div>
                    <h6 class="fs-14">Total Bookings</h6>
                    <span class="fs-14">60</span>
                  </div>
                  <div>
                    <h6 class="fs-14">Payments</h6>
                    <span class="fs-14">4</span>
                  </div>

                  <div>
                    <h6 class="fs-14">Created On</h6>
                    <span class="fs-14">14/01/2024</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-6 col-lg-6">
            <div class="card">
              <div class="card-body">
                <div class="d-flex pb-3 border-bottom mb-4">
                  <h6>Address Info</h6>
                </div>
                <div class="d-flex align-items-center mb-4">
                  <div>
                    <h6 class="me-2 fs-14">Adddress</h6>
                    <span class="fs-14">
                      7865 Oakwood Drive, Apt 5B, Willow Creek Estates</span
                    >
                  </div>
                </div>
                <div
                  class="d-flex justify-content-between align-items-center flex-wrap row-gap-2"
                >
                  <div>
                    <h6 class="fs-14">Country</h6>
                    <span class="fs-14">United States</span>
                  </div>
                  <div>
                    <h6 class="fs-14">State</h6>
                    <span class="fs-14">California</span>
                  </div>
                  <div>
                    <h6 class="fs-14">City</h6>
                    <span class="fs-14">Greenfield</span>
                  </div>

                  <div>
                    <h6 class="fs-14">Zip Code</h6>
                    <span class="fs-14">93927</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-4"
          >
            <h4>Services Info</h4>
            <div class="d-flex align-items-center flex-wrap row-gap-3">
              <span class="fs-14 me-2">Sort</span>
              <div class="dropdown me-2">
                <a
                  href="javascript:void(0);"
                  class="dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Newly Added
                </a>
                <div class="dropdown-menu">
                  <a href="javascript:void(0);" class="dropdown-item active">Ascending</a>
                  <a href="javascript:void(0);" class="dropdown-item">Descending</a>
                </div>
              </div>
              <div class="dropdown me-2">
                <a
                  href="javascript:void(0);"
                  class="dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Export
                </a>
                <div class="dropdown-menu">
                  <a href="javascript:void(0);" class="dropdown-item active"
                    >Export as PDF</a
                  >
                  <a href="javascript:void(0);" class="dropdown-item">Export as Excel</a>
                </div>
              </div>
              <a
                href="javascript:void(0);"
                class="tags d-flex justify-content-center align-items-center border rounded me-2"
                ><i class="ti ti-printer"></i
              ></a>
              <a
                href="javascript:void(0);"
                class="tags d-flex justify-content-center align-items-center border rounded me-2"
                id="filter_search"
                @click="toggleFilterInputs"
                ><i class="ti ti-sort-descending"></i
              ></a>
            </div>
          </div>
          <div
            id="filter_inputs"
            v-bind:style="{ display: showFilterInputs ? 'block' : 'none' }"
          >
            <div class="row">
              <div class="col-lg-3 col-md-6 col-xl">
                <div class="mb-3">
                  <div class="sel-cal Calendar-icon">
                    <span><i class="ti ti-calendar-month"></i></span>
                    <date-picker
                      v-model="startdate"
                      placeholder=""
                      class="datetimepicker form-control"
                      :editable="true"
                      :clearable="false"
                      :input-format="dateFormat"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xl">
                <div class="mb-3">
                  <vue-select
                    :options="CustomSelec"
                    id="customselc"
                    placeholder="Customer ID"
                  />
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xl">
                <div class="mb-3">
                  <vue-select
                    :options="RaySelect"
                    id="rayselect"
                    placeholder="Customer"
                  />
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xl">
                <div class="mb-3">
                  <vue-select
                    :options="CustomActive"
                    id="customactive"
                    placeholder="Status"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="provide-table manage-table">
            <div class="table-responsive">
              <table class="table datatable">
                <thead class="thead-light">
                  <tr>
                    <th>Service Name</th>
                    <th>Booking Date</th>
                    <th>Staff Name</th>
                    <th>Payment Method</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div class="d-flex align-items-center">
                        <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                          <img
                            src="@/assets/img/providers/provider-15.jpg"
                            class="rounded"
                            alt="user"
                          />
                        </router-link>
                        <h6 class="fs-14">
                          <router-link to="/details/service-details">Computer Repair</router-link>
                        </h6>
                      </div>
                    </td>
                    <td>16/04/2024</td>
                    <td class="d-flex align-items-center">
                      <router-link to="/provider/staff-details" class="avatar avatar-lg me-2">
                        <img
                          src="@/assets/img/profiles/avatar-16.jpg"
                          class="rounded-circle"
                          alt="user"
                        />
                      </router-link>
                      <h6 class="fs-14">
                        <router-link to="/provider/staff-details">Jeff Fitch</router-link>
                      </h6>
                    </td>
                    <td>Paypal</td>
                    <td>$2000</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="badge badge-success-100 d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Paid</span
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="d-flex align-items-center">
                        <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                          <img
                            src="@/assets/img/providers/provider-17.jpg"
                            class="rounded"
                            alt="user"
                          />
                        </router-link>
                        <h6 class="fs-14">
                          <router-link to="/details/service-details">Steam Car Wash</router-link>
                        </h6>
                      </div>
                    </td>
                    <td>03/05/2024</td>
                    <td class="d-flex align-items-center">
                      <router-link to="/provider/staff-details" class="avatar avatar-lg me-2">
                        <img
                          src="@/assets/img/profiles/avatar-17.jpg"
                          class="rounded-circle"
                          alt="user"
                        />
                      </router-link>
                      <h6 class="fs-14">
                        <router-link to="/provider/staff-details">Jacob Kline</router-link>
                      </h6>
                    </td>
                    <td>Stripe</td>
                    <td>$1800</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <span
                          class="badge badge-danger-transparent d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Overdue</span
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="d-flex align-items-center">
                        <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                          <img
                            src="@/assets/img/providers/provider-19.jpg"
                            class="rounded"
                            alt="user"
                          />
                        </router-link>
                        <h6 class="fs-14">
                          <router-link to="/details/service-details">House Cleaning </router-link>
                        </h6>
                      </div>
                    </td>
                    <td>22/06/2024</td>
                    <td class="d-flex align-items-center">
                      <router-link to="/provider/staff-details" class="avatar avatar-lg me-2">
                        <img
                          src="@/assets/img/profiles/avatar-33.jpg"
                          class="rounded-circle"
                          alt="user"
                        />
                      </router-link>
                      <h6 class="fs-14">
                        <router-link to="/provider/staff-details">Donald Gordon</router-link>
                      </h6>
                    </td>
                    <td>Stripe</td>
                    <td>$1200</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <span
                          class="badge badge-info-transparent d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Pending</span
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="d-flex align-items-center">
                        <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                          <img
                            src="@/assets/img/providers/provider-14.jpg"
                            class="rounded"
                            alt="user"
                          />
                        </router-link>
                        <h6 class="fs-14">Building Construction</h6>
                      </div>
                    </td>
                    <td>14/06/2024</td>
                    <td class="d-flex align-items-center">
                      <router-link to="/provider/staff-details" class="avatar avatar-lg me-2">
                        <img
                          src="@/assets/img/profiles/avatar-26.jpg"
                          class="rounded-circle"
                          alt="user"
                        />
                      </router-link>
                      <h6 class="fs-14">
                        <router-link to="/provider/staff-details">Kara Coble</router-link>
                      </h6>
                    </td>
                    <td>Paypal</td>
                    <td>$1700</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <span
                          class="badge bg-warning-transparent d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Draft</span
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="d-flex align-items-center">
                        <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                          <img
                            src="@/assets/img/providers/provider-16.jpg"
                            class="rounded"
                            alt="user"
                          />
                        </router-link>
                        <h6 class="fs-14">
                          <router-link to="/details/service-details"
                            >Interior Designing</router-link
                          >
                        </h6>
                      </div>
                    </td>
                    <td>08/07/2024</td>
                    <td class="d-flex align-items-center">
                      <router-link to="/provider/staff-details" class="avatar avatar-lg me-2">
                        <img
                          src="@/assets/img/profiles/avatar-35.jpg"
                          class="rounded-circle"
                          alt="user"
                        />
                      </router-link>
                      <h6 class="fs-14">
                        <router-link to="/provider/staff-details">Jacob Vance</router-link>
                      </h6>
                    </td>
                    <td>Paypal</td>
                    <td>$1100</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="badge badge-success-100 d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Paid</span
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="d-flex align-items-center">
                        <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                          <img
                            src="@/assets/img/providers/provider-23.jpg"
                            class="rounded"
                            alt="user"
                          />
                        </router-link>
                        <h6 class="fs-14">
                          <router-link to="/details/service-details"
                            >Plumbing Services</router-link
                          >
                        </h6>
                      </div>
                    </td>
                    <td>17/08/2024</td>
                    <td class="d-flex align-items-center">
                      <router-link to="/provider/staff-details" class="avatar avatar-lg me-2">
                        <img
                          src="@/assets/img/profiles/avatar-36.jpg"
                          class="rounded-circle"
                          alt="user"
                        />
                      </router-link>
                      <h6 class="fs-14">
                        <router-link to="/provider/staff-details">William Smith</router-link>
                      </h6>
                    </td>
                    <td>Paypal</td>
                    <td>$800</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <span
                          class="badge badge-danger-transparent d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Overdue</span
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="d-flex align-items-center">
                        <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                          <img
                            src="@/assets/img/providers/provider-13.jpg"
                            class="rounded"
                            alt="user"
                          />
                        </router-link>
                        <h6 class="fs-14">
                          <router-link to="/details/service-details"
                            >Car Repair Services</router-link
                          >
                        </h6>
                      </div>
                    </td>
                    <td>22/10/2024</td>
                    <td class="d-flex align-items-center">
                      <router-link to="/provider/staff-details" class="avatar avatar-lg me-2">
                        <img
                          src="@/assets/img/profiles/avatar-52.jpg"
                          class="rounded-circle"
                          alt="user"
                        />
                      </router-link>
                      <h6 class="fs-14">
                        <router-link to="/provider/staff-details">Taylor Pacheco</router-link>
                      </h6>
                    </td>
                    <td>Stripe</td>
                    <td>$1000</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <span
                          class="badge badge-danger-transparent d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Overdue</span
                        >
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            class="table-paginate d-flex justify-content-between align-items-center flex-wrap row-gap-3"
          >
            <div class="value d-flex align-items-center">
              <span>Show</span>
              <select>
                <option>7</option>
              </select>
              <span>entries</span>
            </div>
            <div class="d-flex align-items-center justify-content-center">
              <span class="me-2 text-gray-9">1 - 07 of 10</span>
              <nav aria-label="Page navigation">
                <ul class="paginations d-flex justify-content-center align-items-center">
                  <li class="page-item me-2">
                    <a
                      class="page-link-1 active d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >1</a
                    >
                  </li>
                  <li class="page-item me-2">
                    <a
                      class="page-link-1 d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >2</a
                    >
                  </li>
                  <li class="page-item">
                    <a
                      class="page-link-1 d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >3</a
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
    <customer-grid-modal></customer-grid-modal>
  </div>
</template>
